
export default {
  props: {
    slice: {
      type: Object,
      required: true,
    },
  },

  computed: {
    customProperties() {
      return {
        '--background-image': `url(${this.slice.primary.hero_image.url})`,
      }
    },
  },
}
